const defaultConsortia = [
  {
    "id": 'xxx',
    "label": "999Sepulveda",
    "signerNpub": "",
    "memberPublicKeys": [""]
  }
]
export default defaultConsortia